/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, IconButton, Typography, useTheme} from '@mui/material';

import {useStyles} from './Timeout.styles';
import {useTimeout} from './useTimeout';

interface TimeoutProps {
  sessionCheckInterval?: number;
  tokenExpireThreshold?: number;
  expireIn?: number;
  loggedOut?: boolean;
  isAuthV2?: boolean;
  inActiveTime: number;
  countDownTime: number;
  closeError: (actionType?: string) => void;
  timeOut: () => void;
  staySignIn: () => void;
  refreshSession?: () => void;
  content: {
    staySignedInBtn: string;
    stillThere: string | undefined;
    inActiveMsg: string | undefined;
    signOutBtn: string;
  };
}

export const Timeout: React.FC<TimeoutProps> = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const {
    inActiveTime,
    closeError,
    timeOut,
    staySignIn,
    content,
    countDownTime,
    isAuthV2 = false,
    expireIn = 0,
    loggedOut = true,
    refreshSession = () => 0,
    sessionCheckInterval = 30 * 1000,
    tokenExpireThreshold = 7 * 60 * 1000
  } = props;

  const isAuthV2LoggedOut = isAuthV2 && loggedOut;

  const {seconds, isIdleTimeRef, hasSystemError, setHasSystemError} = useTimeout(
    {
      countDownTime,
      inActiveTime,
      isAuthV2,
      loggedOut,
      expireIn,
      tokenExpireThreshold,
      sessionCheckInterval
    },
    timeOut,
    refreshSession
  );
  const minutes = Math.floor(seconds / 60);
  const secondsLeft = seconds % 60;
  return (
    <Dialog
      className="utah-session-timeout-dialog"
      PaperProps={{style: {borderRadius: '24px', padding: '32px', width: '500px'}}}
      open={isAuthV2LoggedOut ? false : hasSystemError}
      disableScrollLock
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{
        '&.utah-session-timeout-dialog': {
          '& .utah-timeout-head': {position: 'relative', padding: '0px 0px 20px 0px'},
          '& .utah-timeout-close': {position: 'absolute', bottom: '20px', right: '0px', left: 'auto'},
          '& .utah-timeout-footer': {justifyContent: 'flex-end', paddingLeft: '0px'},
          '& .utah-timeout-title': {...theme.typography.h3},
          '& .utah-timeout-body': {...theme.typography.body1},
          '& .utah-timeout-timer': {...theme.typography.h4}
        }
      }}
    >
      <Box className="utah-timeout-head">
        <Typography variant="h3" color="primary" className={`${classes.modalNotification} utah-timeout-title`}>
          <span className="serviceStatus"> {content?.stillThere}</span>
        </Typography>
        <IconButton
          onClick={() => {
            setHasSystemError(false);
            staySignIn();
            isIdleTimeRef.current = false;
          }}
          className="utah-timeout-close"
        >
          <span className="closeIcon" data-testid="close-btn">
            X
          </span>
        </IconButton>
      </Box>
      <DialogContent style={{padding: 0}}>
        <Typography variant="body1" className="utah-timeout-body">
          {/* eslint-disable-next-line react/jsx-curly-brace-presence */}
          {content?.inActiveMsg}{' '}
        </Typography>
        <p className={classes.showTimer}>
          {' '}
          <Typography variant="h4" className="utah-timeout-timer">
            {minutes > 0 ? `${minutes}:` : ''}
            {secondsLeft < 10 ? `0${secondsLeft}` : secondsLeft} seconds
          </Typography>
        </p>
      </DialogContent>
      <DialogActions className="utah-timeout-footer">
        <Button
          // className={classes.buttonStaySignIn}
          onClick={() => {
            setHasSystemError(false);
            staySignIn();
            isIdleTimeRef.current = false;
          }}
          variant="contained"
          color="primary"
          sx={{
            '&.MuiButton-root': {
              borderRadius: '39px',
              bgcolor: 'primary.main'
            }
          }}
        >
          <span className="close">{content?.staySignedInBtn}</span>
        </Button>
        <Button
          // className={classes.buttonSignOut}
          onClick={() => {
            setHasSystemError(false);
            isIdleTimeRef.current = false;
            closeError();
          }}
          variant="contained"
          color="secondary"
          sx={{
            '&.MuiButton-root': {
              borderRadius: '39px',
              bgcolor: 'common.white',
              color: 'primary.main',
              border: '1px solid',
              borderColor: 'primary.main',
              boxShadow: 'none',
              '&:hover': {bgcolor: 'common.white', boxShadow: 'none'}
            }
          }}
        >
          <span className="close">{content?.signOutBtn}</span>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
